import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	const canRwContracts = !!_.get(state.auth.authUser, ['permissions', 'canRwContracts'], false);
	return {
		canRwContracts,
		accessToken: state.auth.accessToken,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
